import store from "./store"
export default {
    dict:{
        Pages_Users:"Pages.Users",
        "Pages_Roles":"Pages.Roles",
        "Pages_Tenants":"Pages.Tenants",
        "Pages_NewCars":"Pages.NewCars",
        "Console_Dic":"Console_Dic",
        "Console_ViewBaseTable":"Console.ViewBaseTable",
        "Console_ViewBaseTable_Factory":"Console.ViewBaseTable_Factory",
        "Console.BaseTable_Brand":"Console.BaseTable_Brand",
        "Console.BaseTable_Product":"Console.BaseTable_Product",
        "Console.BaseTable_ProductLModel":"Console.BaseTable_ProductLModel",
        "Console.BaseTable_Market":"Console.BaseTable_Market",
        "Console.BaseTable_Line":"Console.BaseTable_Line",
        "Console.ViewEquipParams":"Console.ViewEquipParams",
        "Console.ViewPv":"Console.ViewPv",
        "Console.ViewMsrp":"Console.ViewMsrp",
        "Console.ViewSales":"Console.ViewSales",
        "Console_ViewMix":"Console_ViewMix",
        "Console_ViewMixCity":"Console_ViewMixCity",
        "Console_ViewPvaSet":"Console_ViewPvaSet",
        "Client_ViewSales_Model":"Client.ViewSales.Model",
        "Client_ViewSales_Model_Down":"Client.ViewSales.Model.Down",
        "Client_ViewSales_Line":"Client.ViewSales.Line",
        "Client_ViewSales_Line_Down":"Client.ViewSales.Line.Down",
        "Client_ViewSales_Eq":"Client.ViewSales.Eq",
        "Client_ViewSales_Eq_Down":"Client.ViewSales.Eq.Down",
        "Client_ViewLine_EqData":"Client.ViewLine.EqData",
        "Client_ViewLine_EqData_Down":"Client.ViewLine.EqData.Down",
        "Client_ViewLine_Gradient":"Client.ViewLine.Gradient",
        "Client_ViewLine_Gradient_Down":"Client.ViewLine.Gradient.Down",
        "Client_ViewLine_LineEq":"Client.ViewLine.LineEq",
        "Client_ViewLine_LineEq_Down":"Client.ViewLine.LineEq.Down",
        "Client_ViewLine_ModelEq":"Client.ViewLine.ModelEq",
        "Client_ViewLine_ModelEq_Down":"Client.ViewLine.ModelEq.Down",
        "Client_ViewAnalysis_LifeCycle":"Client.ViewAnalysis.LifeCycle",
        "Client_ViewAnalysis_LifeCycle_Down":"Client.ViewAnalysis.LifeCycle.Down",
        "Client_ViewAnalysis_PriceLadder":"Client.ViewAnalysis.PriceLadder",
        "Client_ViewAnalysis_PriceLadder_Down":"Client.ViewAnalysis.PriceLadder.Down",
        "Client_ViewAnalysis_EqRate":"Client.ViewAnalysis.EqRate",
        "Client_ViewAnalysis_EqRate_Down":"Client.ViewAnalysis.EqRate.Down",
        "Client_ViewAnalysis_ThreeDimensional":"Client.ViewAnalysis.ThreeDimensional",
        "Client_ViewAnalysis_ThreeDimensional_Down":"Client.ViewAnalysis.ThreeDimensional.Down",
        "Client_ViewAnalysis_Pva":"Client.ViewAnalysis.Pva",
        "Client_ViewAnalysis_Pva_Down":"Client.ViewAnalysis.Pva.Down",
        "Client_ViewNewCar_Report":"Client.ViewNewCar.Report",
        "Client_ViewNewCar_Report_Down":"Client.ViewNewCar.Report.Down",
        "Client_ViewReport_Day":"Client.ViewReport.Day",
        "Client_ViewReport_Day_Down":"Client.ViewReport.Day.Down",
        "Client_ViewReport_Month":"Client.ViewReport.Month",
        "Client_ViewReport_Month_Down":"Client.ViewReport.Month.Down",
        "Console_UserInfos_Create":"Console_UserInfos_Create",
        "Console_UserInfos_Del":"Console_UserInfos_Del",
        "Console_UserInfos_Edit":"Console_UserInfos_Edit",
        "Console_RolesInfos_Create":"Console_RolesInfos_Create",
        "Console_RolesInfos_Edit":"Console_RolesInfos_Edit",
        "Pages.NewCars.Import":"Pages.NewCars.Import",
        "Console_Dic_L4Create":"Console_Dic_L4Create",
        "Console_Dic_L4Export":"Console_Dic_L4Export",
        "Console_Dic_L5Export":"Console_Dic_L5Export",
        "Console_Dic_L4Edit":"Console_Dic_L4Edit",
        "Console_Dic_L4Del":"Console_Dic_L4Del",
        "Console_Dic_L4Add":"Console_Dic_L4Add",
        "Console_Dic_L5Edit":"Console_Dic_L5Edit",
        "Console_Dic_L5Del":"Console_Dic_L5Del",
        "Console.ImportBaseTable":"Console.ImportBaseTable",
        "Console.ExportBaseTable":"Console.ExportBaseTable",
        "Console.QueryBaseTable":"Console.QueryBaseTable",
        "Console_BaseTable_Edit":"Console_BaseTable_Edit",
        "Console.BaseTable_Factory_Add":"Console.BaseTable_Factory_Add",
        "Console.BaseTable_Factory_Query":"Console.BaseTable_Factory_Query",
        "Console_BaseTable_Factory_Edit":"Console_BaseTable_Factory_Edit",
        "Console_BaseTable_Factory_Del":"Console_BaseTable_Factory_Del",
        "Console.BaseTable_Brand_Add":"Console.BaseTable_Brand_Add",
        "Console.BaseTable_Brand_Query":"Console.BaseTable_Brand_Query",
        "Console_BaseTable_Brand_Edit":"Console_BaseTable_Brand_Edit",
        "Console_BaseTable_Brand_Del":"Console_BaseTable_Brand_Del",
        "Console.BaseTable_Product_Add":"Console.BaseTable_Product_Add",
        "Console.BaseTable_Product_Query":"Console.BaseTable_Product_Query",
        "Console_BaseTable_Product_Edit":"Console_BaseTable_Product_Edit",
        "Console_BaseTable_Product_Del":"Console_BaseTable_Product_Del",
        "Console.ProductLModel_Add":"Console.ProductLModel_Add",
        "Console.ProductLModel_Query":"Console.ProductLModel_Query",
        "Console_BaseTable_ProductLModel_Edit":"Console_BaseTable_ProductLModel_Edit",
        "Console_BaseTable_ProductLModel_Del":"Console_BaseTable_ProductLModel_Del",
        "Console_BaseTable_Market_Delete":"Console_BaseTable_Market_Delete",
        "Console.BaseTable_Market_Add":"Console.BaseTable_Market_Add",
        "Console.BaseTable_Market_Query":"Console.BaseTable_Market_Query",
        "Console.BaseTable_Market_Import":"Console.BaseTable_Market_Import",
        "Console.BaseTable_Market_Export":"Console.BaseTable_Market_Export",
        "Console_BaseTable_Line_Query":"Console_BaseTable_Line_Query",
        "Console_BaseTable_Line_SurelAudit":"Console_BaseTable_Line_SurelAudit",
        "Console_BaseTable_Line_Audit":"Console_BaseTable_Line_Audit",
        "Console.BaseTable_Line_Import":"Console.BaseTable_Line_Import",
        "Console.BaseTable_Line_Export":"Console.BaseTable_Line_Export",
        "Console.BaseTable_Line_Delete":"Console.BaseTable_Line_Delete",
        "Console.BaseTable_Line_ConfigSheet_Up":"Console.BaseTable_Line_ConfigSheet_Up",
        "Console.BaseTable_Line_ConfigSheet_Down":"Console.BaseTable_Line_ConfigSheet_Down",
        "Console.ImportEquipParams":"Console.ImportEquipParams",
        "Console.ExportEquipParams":"Console.ExportEquipParams",
        "Console.QueryEquipParams":"Console.QueryEquipParams",
        "Console_AddPv":"Console_AddPv",
        "Console.ImportPv":"Console.ImportPv",
        "Console.ExportPv":"Console.ExportPv",
        "Console.QueryPv":"Console.QueryPv",
        "Console.ImportMsrp":"Console.ImportMsrp",
        "Console.ExportMsrp":"Console.ExportMsrp",
        "Console.DeleteMsrp":"Console.DeleteMsrp",
        "Console.QueryMsrp":"Console.QueryMsrp",
        "Console.ImportSales":"Console.ImportSales",
        "Console.ExportSales":"Console.ExportSales",
        "Console.DeleteSales":"Console.DeleteSales",
        "Console.QuerySales":"Console.QuerySales",
        "Console.SalesCategory":"Console.SalesCategory",
        "Console_ImportMix":"Console_ImportMix",
        "Console_ExportMix":"Console_ExportMix",
        "Console_DiffMix":"Console_DiffMix",
        "Console_QueryMix":"Console_QueryMix",
        "Console_ViewMixCity_Query":"Console_ViewMixCity_Query",
        "Console_ViewMixCity_Save":"Console_ViewMixCity_Save",
        "Console_ViewMixCity_Cancel":"Console_ViewMixCity_Cancel",
        "Console_ViewPvaSet_Query":"Console_ViewPvaSet_Query",
        "Console_ViewPvaSet_Save":"Console_ViewPvaSet_Save",
        "Console_ViewPvaSet_Cancel":"Console_ViewPvaSet_Cancel",
        "Client_MADE_Index_View": "Client.Made.Index.View",
        "Client_MADE_Index_Down":  "Client.Made.Index.Down",
        "Client_MADE_Charts_View": "Client.Made.Charts.View",
        "Client_MADE_Charts_Down": "Client.Made.Charts.Down",
     
        "Client_ViewSchema": "Client.ViewSchema",
        "Client_ViewSchemaCenter":"Client.ViewSchemaCenter",
        "Client_SaveSchema": "Client.SaveSchema",
        "Client_ShareScema": "Client.ShareScema",
    
 
    
    },
      check(key) {
         var cfg = store.getters["user/userConfig"];
        if(!cfg || cfg.auth.grantedPermissions[key]==undefined)
        {
            return false;
        }
       return  cfg.auth.grantedPermissions[key];
    },
  


    Client_ViewSales_Model (){ return  this.check(this.dict.Client_ViewSales_Model);} ,
    Client_ViewSales_Model_Down(){return this.check(this.dict.Client_ViewSales_Model_Down)},
    Client_ViewSales_Line()  { return this.check(this.dict.Client_ViewSales_Line)},
    Client_ViewSales_Line_Down() { return this.check(this.dict.Client_ViewSales_Line_Down)},
    Client_ViewSales_Eq() { return this.check(this.dict.Client_ViewSales_Eq)},
    Client_ViewSales_Eq_Down (){return  this.check(this.dict.Client_ViewSales_Eq_Down)},
    Client_ViewLine_EqData (){return  this.check(this.dict.Client_ViewLine_EqData)},
    Client_ViewLine_EqData_Down (){return  this.check(this.dict.Client_ViewLine_EqData_Down)},
    Client_ViewLine_Gradient (){return  this.check(this.dict.Client_ViewLine_Gradient)},
    Client_ViewLine_Gradient_Down (){return  this.check(this.dict.Client_ViewLine_Gradient_Down)},
    Client_ViewLine_LineEq (){return  this.check(this.dict.Client_ViewLine_LineEq)},
    Client_ViewLine_LineEq_Down (){return  this.check(this.dict.Client_ViewLine_LineEq_Down)},
    Client_ViewLine_ModelEq (){return  this.check(this.dict.Client_ViewLine_ModelEq)},
    Client_ViewLine_ModelEq_Down (){return  this.check(this.dict.Client_ViewLine_ModelEq_Down)},
    Client_ViewAnalysis_LifeCycle (){return  this.check(this.dict.Client_ViewAnalysis_LifeCycle)},
    Client_ViewAnalysis_LifeCycle_Down (){return  this.check(this.dict.Client_ViewAnalysis_LifeCycle_Down)},
    Client_ViewAnalysis_PriceLadder (){return  this.check(this.dict.Client_ViewAnalysis_PriceLadder)},
    Client_ViewAnalysis_PriceLadder_Down (){return  this.check(this.dict.Client_ViewAnalysis_PriceLadder_Down)},
    Client_ViewAnalysis_EqRate (){return  this.check(this.dict.Client_ViewAnalysis_EqRate)},
    Client_ViewAnalysis_EqRate_Down (){return  this.check(this.dict.Client_ViewAnalysis_EqRate_Down)},
    Client_ViewAnalysis_ThreeDimensional (){return  this.check(this.dict.Client_ViewAnalysis_ThreeDimensional)},
    Client_ViewAnalysis_ThreeDimensional_Down (){return  this.check(this.dict.Client_ViewAnalysis_ThreeDimensional_Down)},
    Client_ViewAnalysis_Pva (){return  this.check(this.dict.Client_ViewAnalysis_Pva)},
    Client_ViewAnalysis_Pva_Down (){return  this.check(this.dict.Client_ViewAnalysis_Pva_Down)},
    Client_ViewNewCar_Report (){return  this.check(this.dict.Client_ViewNewCar_Report)},
    Client_ViewNewCar_Report_Down (){return  this.check(this.dict.Client_ViewNewCar_Report_Down)},
    Client_ViewReport_Day() { return this.check(this.dict.Client_ViewReport_Day)},
    Client_ViewReport_Day_Down (){return  this.check(this.dict.Client_ViewReport_Day_Down)},
    Client_ViewReport_Month (){return  this.check(this.dict.Client_ViewReport_Month)},
    Client_ViewReport_Month_Down (){return  this.check(this.dict.Client_ViewReport_Month_Down)},

    Client_MADE_Index_View() {return this.check( this.dict.Client_MADE_Index_View)},
    Client_MADE_Index_Down () {return this.check( this.dict.Client_MADE_Index_Down)},

    Client_MADE_Charts_View () {return this.check( this.dict.Client_MADE_Charts_View)},
    Client_MADE_Charts_Down () {return this.check( this.dict.Client_MADE_Charts_Down)},

    Client_ViewSchema () {return this.check( this.dict.Client_ViewSchema)},
    Client_ViewSchemaCenter () {return this.check( this.dict.Client_ViewSchemaCenter)},
    Client_SaveSchema () {return this.check( this.dict.Client_SaveSchema)},
    Client_ShareScema () {return this.check( this.dict.Client_ShareScema)},
 

    client_view_nav_depth(){ 
            return this.Client_ViewAnalysis_LifeCycle() 
            || this.Client_ViewAnalysis_PriceLadder() 
            || this.Client_ViewAnalysis_EqRate() 
            || this. Client_ViewAnalysis_ThreeDimensional() 
            || this.Client_ViewAnalysis_Pva()
            || this.Client_ViewReport_Day() 
            || this.Client_ViewReport_Month();

    },

    client_view_nav_sale(){ 
        return this.Client_ViewSales_Model() 
        || this.Client_ViewSales_Line() 
        || this.Client_ViewSales_Eq() ;
    },
    client_view_nav_equip(){ 
        return this.Client_ViewSales_Eq() 
        || this.Client_ViewLine_EqData() 
        || this.Client_ViewLine_Gradient() 
        || this.Client_ViewLine_LineEq() 
        || this.Client_ViewLine_ModelEq() ;
    },

    client_view_made(){
    return this.Client_MADE_Index_View() 
    || this.Client_MADE_Index_Down()
    || this.Client_MADE_Charts_View()
    || this.Client_MADE_Charts_Down()
    },

    client_view_schema(){
        return this.Client_ViewSchema()
        || this.Client_ViewSchemaCenter()
        || this.Client_SaveSchema()
        || this.Client_ShareScema()
    }

}